import { PaginationUpdateEvent } from 'ui/paginationFooter';
import { usePaginationContext } from 'utils/contexts/pagination';

export const usePagination = () => {
  const {
    currentPage,
    pageSize: itemsPerPage,
    setCurrentPage,
    setPageSize,
  } = usePaginationContext();

  const handlePaginationUpdate = ({ pageSize, page }: PaginationUpdateEvent) => {
    setCurrentPage(page);
    setPageSize(pageSize);
  };

  return { currentPage, itemsPerPage, handlePaginationUpdate };
};
